export class TournamentScheduleService {
    repository;
    constructor(repository) {
        this.repository = repository;
    }
    async scheduleRounds(tournament, rounds) {
        if (!this.shouldScheduleRounds(tournament))
            return;
        const sortedRounds = this.sortRoundsByNumber(rounds);
        const roundInterval = this.calculateRoundDurationInMinutes(tournament);
        const currentRound = this.getCurrentRound(tournament, sortedRounds);
        console.log("scheduleRounds -> current round", currentRound);
        const nextRoundStartTime = this.calculateNextRoundStartTime(tournament, currentRound);
        await this.scheduleRemainingRounds(tournament, sortedRounds, roundInterval, nextRoundStartTime);
    }
    shouldScheduleRounds(tournament) {
        return tournament && tournament.currentRound <= tournament.totalRounds;
    }
    sortRoundsByNumber(rounds) {
        return [...rounds].sort((a, b) => a.roundNumber - b.roundNumber);
    }
    calculateRoundDurationInMinutes(tournament) {
        return tournament.baseTimeControl * 2 + 2; // minutes
    }
    getCurrentRound(tournament, sortedRounds) {
        return tournament.currentRound
            ? sortedRounds[tournament.currentRound - 1]
            : null;
    }
    calculateNextRoundStartTime(tournament, currentRound) {
        if (!currentRound) {
            // Ensure round 1 starts after tournament start time
            return tournament.startTime.seconds + 1;
        }
        if (currentRound.finishTime) {
            return currentRound.finishTime.seconds;
        }
        if (currentRound.startTime) {
            return (currentRound.startTime.seconds +
                60 * this.calculateRoundDurationInMinutes(tournament));
        }
        return Math.max(Date.now() / 1000 + 60, tournament.startTime.seconds);
    }
    async scheduleRemainingRounds(tournament, sortedRounds, roundInterval, startTime) {
        console.log("scheduleRemainingRounds", tournament.currentRound + 1, tournament.totalRounds, "tournament start time", tournament.startTime.toDate());
        for (let roundNumber = tournament.currentRound + 1; roundNumber <= tournament.totalRounds; ++roundNumber) {
            const roundStartTime = this.calculateRoundStartTime(startTime, roundInterval, roundNumber, tournament.currentRound);
            console.log(`schedule round ${roundNumber}, start time`, roundStartTime);
            await this.setRoundStartTime(tournament, sortedRounds, roundNumber, roundStartTime);
        }
    }
    calculateRoundStartTime(startTime, roundInterval, roundNumber, currentRound) {
        return new Date(1000 *
            (startTime + 60 * roundInterval * (roundNumber - currentRound - 1)) +
            1);
    }
    async setRoundStartTime(tournament, rounds, roundNumber, date) {
        if (date < tournament.startTime.toDate()) {
            console.log(`skip schedule round ${roundNumber}, date ${date} < tournament start time ${tournament.startTime.toDate()}`);
            return;
        }
        if (roundNumber > 1 &&
            rounds[roundNumber - 2] &&
            date < rounds[roundNumber - 2].startTime.toDate()) {
            console.log(`skip schedule round ${roundNumber}, date ${date} < round ${roundNumber - 2}'s start time ${rounds[roundNumber - 2].startTime.toDate()}`);
            return;
        }
        await this.repository.updateRoundStartTime(tournament.id, roundNumber, date);
    }
    async pushRounds(tournament, rounds, roundNumber, minutes) {
        const comingRounds = this.getComingRounds(tournament, rounds, roundNumber);
        await this.updateRoundStartTimes(tournament, comingRounds, minutes);
    }
    getComingRounds(tournament, rounds, startingRound) {
        return rounds.filter((round) => round.roundNumber >= startingRound &&
            round.roundNumber <= tournament.totalRounds &&
            round.roundNumber >= tournament.currentRound);
    }
    async updateRoundStartTimes(tournament, rounds, minutes) {
        const updates = rounds.map((round) => this.repository.updateRoundStartTime(tournament.id, round.roundNumber, new Date(1000 * (round.startTime.seconds + minutes * 60))));
        await Promise.all(updates);
    }
}
